import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundImage: `url(${"assets/background.jpg"})`,
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    padding: "24px",
    borderRadius: "8px",
    boxShadow: tokens.shadow8,
    textAlign: "center",
    maxWidth: "300px",
    width: "90%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  logo: {
    width: "350px",
    marginBottom: "16px",
  },
  buttonSignin: {
    cursor: "pointer",
  },

  loginsuccess: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    padding: "24px",
    fontSize: "20px",
  },
  loginerror: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "50%",
    margin: "0 auto",
    padding: "24px",
    fontSize: "20px",
  },
  radio: {
    "& .ant-radio-label, & .ant-radio-group, & .ant-radio-wrapper": {
      width: '100%',
    },
  },
  center: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  // Menu styling for selected items
  menuStyles: {
    "& .ant-menu-submenu-selected > .ant-menu-submenu-title": {
      color: "#ff5c35 !important",
      fontWeight: "normal !important",
      backgroundColor: "transparent !important",
    },
    "& .ant-menu-item-selected": {
      color: "#ff5c35 !important",
      fontWeight: "normal !important",
      backgroundColor: "transparent !important",
    },
    "& .ant-menu-submenu-open .ant-menu-sub .ant-menu-item-selected": {
      color: "white !important",
      fontWeight: "bold !important",
      backgroundColor: "transparent !important",
    },
    "& .ant-menu-sub.ant-menu-inline": {
      backgroundColor: "transparent !important",
    }
  },
  infoPopover: {
    color: "#6B7280 !important",
    cursor: "pointer",
    "&:hover": {
      color: "#ff5c35",
    }
  },
  tradedFundsRecommendationTypeRadio: {
    position: 'relative',
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'flex-start',
    zIndex: 1,
    "&::before": {
      content: '""',
      display: 'block',
      position: 'absolute',
      zIndex: 0,
      width: 'calc(66.67% - 6px)',
      height: '1px',
      backgroundColor: '#000',
      top: "6px",
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
    }
  }
});
